import React from "react";
import { cn } from "../../../utils/tw";

interface PrimaryButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  loading,
  className,
  children,
  ...props
}) => (
  <button
    {...props}
    disabled={loading || props.disabled}
    className={cn(
      'bg-gradient-to-r from-ds-primary-500 to-ds-primary-600 text-text-inverse font-semibold px-6 py-3 rounded-xl',
      'shadow-lg shadow-ds-primary-500/30 hover:shadow-xl hover:shadow-ds-primary-500/40 transform hover:-translate-y-0.5',
      'transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed',
      'focus:outline-none focus:ring-4 focus:ring-ds-primary-500/30',
      'flex items-center justify-center gap-2 min-h-[44px]',
      className
    )}
  >
    {loading && (
      <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
      </svg>
    )}
    {children}
  </button>
);

export default PrimaryButton;
